import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalCompleteAudit from "root/Modals/ModalCompleteAudit";

const useModalCompleteAudit = () =>
{
    const CLOSED_MODE = { openState: false, survey_type: null, provider_id: null, provider_table_instance_id: null, audit_review_status: null, mode: null, onSaveCompleted: null } ;

    const [dialog, setDialog]  = useState ( CLOSED_MODE )   ;

    const onClick = ( provider_id, survey_type, provider_table_instance_id, audit_review_status, mode, onCompleteFunction ) =>
    {
        setDialog ({ openState: true, survey_type: survey_type, provider_id: provider_id, provider_table_instance_id: provider_table_instance_id, audit_review_status: audit_review_status, mode: mode, onSaveCompleted: onCompleteFunction });
    }

    const onCloseModal = ( result ) =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted( result ) ;
        }

        setDialog ( CLOSED_MODE );
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalCompleteAudit onClose={onCloseModal} provider_id={dialog.provider_id} params={dialog} mode={dialog.mode} />
            </Modal>
        )
    }

    return [ render, onClick ] ;
}

export default useModalCompleteAudit ;
